import React from 'react'
import styled from 'styled-components'
import { Body } from 'src/Styles/text-styles'

const Container = styled.div`
  display: flex;
`

const BoldBody = styled(Body)`
  font-weight: 600;
  padding-right: 8px;
  padding-left: 16px;
  line-height: 28px;
  letter-spacing: 0.5px;
`

const Body1 = styled(Body)`
  line-height: 28px;
  letter-spacing: 0.5px;
`

interface Props {
  speed: string
  speedDescription: string
}

export default ({ speed, speedDescription }: Props) => {
  return (
    <Container>
      <BoldBody>{speed}</BoldBody>
      <Body1>{speedDescription}</Body1>
    </Container>
  )
}
